import { MatchmakingStrategy, MatchType, PlayerGrouping } from '@nova/types';

import { assetLobbyThumbTerraforming } from './asset-bundle-names';

export const mapConfigTfLiteral = [
  {
    type: MatchType.terraforming,
    id: 'tf-coop-25',
    assetName: 'tf-coop-25',
    name: 'loc:::map_config_terraforming_coop_25_name',
    teamCount: 1,
    teamSize: 25,
    playerGrouping: PlayerGrouping.MP_COOP,
    isAvailable: false,
    matchmakingConfig: {
      strategy: MatchmakingStrategy.QUEUED_TEAM_MATCH,
      scopePolicy: 'prefer_class_during_school_hours'
    },
    enginePrepConfig: {
      fillEmptySlotsWithAi: false
    },
    lobbyConfig: {
      title: 'loc:::game_list_terraforming_name',
      subtitle: 'loc:::map_config_terraforming_coop_25_name',
      dataKey: assetLobbyThumbTerraforming
    }
  }
] as const;
